<app-navbar />

<main id="main-content">
  <section class="page-hero contact-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'Contact' }]" />
      <span class="eyebrow">Contact us</span>
      <h1>Talk to a real person about your data</h1>
      <p>
        Tell us your use case and volume and we will show you exactly what a match looks like on your
        own records. Most evaluations start with a free sample file, not a sales call.
      </p>
      <ul class="contact-promise">
        @for (promise of promises; track promise) {
          <li>{{ promise }}</li>
        }
      </ul>
    </div>
  </section>

  <section class="section contact-section">
    <div class="container">
      <div class="contact-layout">
        <div class="contact-form-wrap">
          @if (!submitted()) {
            <div class="contact-form-head">
              <h2>Send us a message</h2>
              <p>We reply by the next business day, usually sooner.</p>
            </div>

            <form class="contact-form" (ngSubmit)="submit()" #form="ngForm">
              <div class="field-row">
                <div class="field">
                  <label for="name">Full name <span class="req" aria-hidden="true">*</span></label>
                  <input id="name" name="name" type="text" autocomplete="name" placeholder="Jane Miller"
                    [(ngModel)]="model.name" required />
                </div>
                <div class="field">
                  <label for="email">Work email <span class="req" aria-hidden="true">*</span></label>
                  <input id="email" name="email" type="email" autocomplete="email"
                    placeholder="jane@yourcompany.com" [(ngModel)]="model.email" required />
                </div>
              </div>

              <div class="field-row">
                <div class="field">
                  <label for="company">Company</label>
                  <input id="company" name="company" type="text" autocomplete="organization"
                    placeholder="Your company" [(ngModel)]="model.company" />
                </div>
                <div class="field">
                  <label for="phone">Phone</label>
                  <input id="phone" name="phone" type="tel" autocomplete="tel" placeholder="Optional"
                    [(ngModel)]="model.phone" />
                </div>
              </div>

              <div class="field">
                <span class="field-legend">What brings you here?</span>
                <div class="choice-row" role="group" aria-label="Reason for contact">
                  @for (topic of topics; track topic.value) {
                    <button type="button" class="choice" [class.selected]="model.topic === topic.value"
                      [attr.aria-pressed]="model.topic === topic.value" (click)="model.topic = topic.value">
                      {{ topic.label }}
                    </button>
                  }
                </div>
              </div>

              <div class="field">
                <label for="volume">Estimated monthly volume</label>
                <select id="volume" name="volume" [(ngModel)]="model.volume">
                  <option value="">Select a range</option>
                  <option value="under-10k">Under 10,000 records</option>
                  <option value="10k-100k">10,000 to 100,000 records</option>
                  <option value="100k-500k">100,000 to 500,000 records</option>
                  <option value="500k-plus">500,000 or more records</option>
                </select>
              </div>

              <div class="field">
                <label for="message">How can we help?</label>
                <textarea id="message" name="message" rows="4"
                  placeholder="Tell us about the records you need to screen and where it fits in your process."
                  [(ngModel)]="model.message"></textarea>
              </div>

              <button class="btn btn-primary btn-lg btn-block" type="submit" [disabled]="form.invalid">
                Send message
              </button>
              <p class="form-note">
                We only use your details to answer your enquiry. Read our
                <a [routerLink]="[routes.privacy.url]">privacy policy</a>.
              </p>
            </form>
          } @else {
            <div class="form-success">
              <span class="icon-badge" [innerHTML]="iconFor('check')"></span>
              <h2>Thanks, we have your message</h2>
              <p>
                A member of our team will get back to you at the email you provided, usually by the
                next business day. If it is urgent, call {{ site.phone }} and ask for sales.
              </p>
              <div class="actions-row center">
                <a class="btn btn-primary" [routerLink]="[routes.bookACall.url]">Book a call instead</a>
                <a class="btn btn-outline" [routerLink]="[routes.home.url]">Back to home</a>
              </div>
            </div>
          }
        </div>

        <aside class="contact-aside">
          <div class="contact-card contact-card-dark">
            <span class="contact-card-eyebrow">Prefer to talk now?</span>
            <a class="contact-phone" [href]="site.phoneHref">{{ site.phone }}</a>
            <p>Monday to Friday, 9am to 6pm Pacific. A person answers, not a queue.</p>
            <a class="btn btn-accent btn-block" [routerLink]="[routes.bookACall.url]">Schedule a call</a>
          </div>

          <div class="contact-card">
            <h2>Direct contacts</h2>
            @for (item of channels; track item.label) {
              <div class="info-item">
                <span class="icon-badge" aria-hidden="true" [innerHTML]="iconFor(item.icon)"></span>
                <div class="info-text">
                  <span class="info-label">{{ item.label }}</span>
                  @if (item.href) {
                    <a [href]="item.href">{{ item.value }}</a>
                  } @else {
                    <span class="info-value">{{ item.value }}</span>
                  }
                  <span class="info-detail">{{ item.detail }}</span>
                </div>
              </div>
            }
          </div>

          <div class="contact-card contact-card-quiet">
            <h2>Answers without waiting</h2>
            <p>Most evaluation questions are already written down.</p>
            <ul class="contact-links">
              <li><a [routerLink]="[routes.pricing.url]">Pricing and billing</a></li>
              <li><a [routerLink]="[routes.security.url]">Security and compliance pack</a></li>
              <li><a [routerLink]="[routes.developers.url]">API documentation</a></li>
              <li><a [routerLink]="[routes.faq.url]">Frequently asked questions</a></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  </section>
</main>

<app-footer />
